// 9fbef606107a605d69c0edbcd8029e5d
import CREATE_ACCOUNT_CONSTANTS from '../CreateAccount.constants';

export const createAccount = (payload) => ({
  type: CREATE_ACCOUNT_CONSTANTS.CREATE_AN_ACCOUNT,
  payload,
});

export const setShowOTPScreen = (payload) => ({
  type: CREATE_ACCOUNT_CONSTANTS.SET_SHOW_OTP_SCREEN,
  payload,
});

export const setIsFromCreateAccountFlow = (payload) => ({
  type: CREATE_ACCOUNT_CONSTANTS.IS_FROM_CREATE_ACCOUNT_FLOW,
  payload,
});

export const createAccountErr = (payload) => ({
  type: CREATE_ACCOUNT_CONSTANTS.CREATE_AN_ACCOUNT_ERR,
  payload,
});

export const resetCreateAccountErr = () => ({
  type: CREATE_ACCOUNT_CONSTANTS.RESET_CREATE_AN_ACCOUNT_ERR,
});

export const setLoadingState = (payload) => ({
  type: CREATE_ACCOUNT_CONSTANTS.SET_LOADING_STATE,
  payload,
});

export const setShowVerificationError = (payload) => ({
  type: CREATE_ACCOUNT_CONSTANTS.SHOW_VERIFICATION_ERROR,
  payload,
});

export const setShowBriteError = (payload) => ({
  type: CREATE_ACCOUNT_CONSTANTS.SHOW_BRITE_ERROR,
  payload,
});

export const setBriteErrorMessage = (payload) => ({
  type: CREATE_ACCOUNT_CONSTANTS.BRITE_ERROR_MESSAGE,
  payload,
});
